// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hh8B9","left":"styles_left__3U-sU","desktopActions":"styles_desktopActions__2w0-M","title":"styles_title__3U-S6"};